import React from 'react';
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
// import Quote from '../quote'
// import Modal from 'react-modal';
// import { SigningModal } from '../modals'
// import { SvgCheckIcon, SvgArrowIcon } from '../svg';
// import { nextStep } from '../../api/gui/actions'
import connectWithStore from '../../utils/store'
import Alert from 'react-bootstrap/Alert'

import { customerNameById, formatKennitala, formatKennitalaAsDate, Spinner, getDescriptiveContractName } from '../../utils'
import { getStepOrder } from '../../constants';
import { Redirect } from 'react-router-dom';


var timers = {}


class TilbodStepNoSignature extends React.Component {

    constructor(props) {
        super(props)
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    render() {
        const { contractSigning, isFetching, error_list, status } = this.props.offers
        let CORRECT_STEP_ORDER = getStepOrder(this.props.offers.offerQueryParameters);
        return (
            <>
                <div className="row justify-content-center xs-pt-10 signature">
                    <>
                    <div className="col-12 text-center xs-pt-10">
                        <h3>Gagnasöfnun lokið</h3>
                    </div>
                    { status === 'error' ?
                        <Alert variant="danger" className="xs-mt-40 xs-p-30">
                            <Alert.Heading>Villa kom upp við innsendingu samnings</Alert.Heading>
                            {error_list.map((error, idx) => 
                                <React.Fragment key={`error-${idx}`}>
                                    <hr />
                                    <p>
                                        {error} 
                                    </p>
                                    
                                </React.Fragment>
                            )}
                        </Alert>
                    :
                        <>
                            <div className="col-8">
                                {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) => 
                                <React.Fragment key={customerId}>
                                    {Object.keys(this.props.offers.offerQueryParameters[customerId]).map((key, val) =>
                                        <div key={`${customerId}-${key}`} className="final-insurance-list">
                                            <h3>{getDescriptiveContractName(key)}</h3>
                                            <h3>{formatKennitala(customerId)}</h3>
                                        </div>
                                    )}
                                </React.Fragment>
                                )}
                            </div>
                        </>
                    }
                    </>
                </div>
                { status !== 'error' &&
                    <TilbodNavigation />
                }
            </>
        )
    }
}

TilbodStepNoSignature.defaultProps = {}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        healthQuestions: {},
        payers: {},
        employers: {},
        insuranceTakers: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.employers = (state.employers === undefined) ? {} : state.employers
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    return f;
}

export default connectWithStore(store, TilbodStepNoSignature, mapStateToProps);
